export default __webpack_public_path__ + "static/media/loc2.81fafe19.png";